import axios from "axios";
import Cookies from 'js-cookie';
import config from "../../config";

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Obtener participantes con estado del acta por departamento
export async function getParticipantesActa(id_municipio) {
    const response = await api.get(`/api/getParticipantesActa/${id_municipio}`);
    return response.data;
}

// Subir o reemplazar acta de un participante
export async function subirActaParticipante(oid_participante, archivo, cargado_por, departamento, municipio) {
    const formData = new FormData();
    formData.append('departamento', departamento);
    formData.append('municipio', municipio);
    if (cargado_por) formData.append('cargado_por', cargado_por);
    formData.append('archivo', archivo);

    const response = await api.post(
        `/api/actas-participantes/subir/${oid_participante}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
}


// Descarga individual
export async function getDescargarActaParticipante(oid_participante, nombreArchivo) {
    const response = await api.get(
        `/api/actas-participantes/descargar/${oid_participante}`,
        { responseType: 'blob' }  // 👈 imprescindible para archivos binarios
    );

    // Dispara la descarga en el navegador
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo ?? 'acta.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}



//Descarga masiva
export async function descargarActasMasivo(oids = [], nombreZip) {
    const response = await api.post(
        '/api/actas-participantes/descargar-masivo',
        { oids },
        { responseType: 'blob' }
    );

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreZip ?? `actas_${Date.now()}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
